import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ef68044"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "link-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Aziz Stark", -1))
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_profile_image = _resolveComponent("profile-image")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, { to: "/about" }, {
          default: _withCtx(() => [
            _createVNode(_component_profile_image),
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.siteLinks, (link) => {
        return (_openBlock(), _createElementBlock("a", {
          class: "link-button",
          key: link.name,
          href: link.link,
          rel: "noreferrer noopener",
          target: "_blank"
        }, _toDisplayString(link.name), 9, _hoisted_4))
      }), 128))
    ])
  ]))
}